import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
// Slider组件
import Slider from "./../Slider.vue";
import { toast, showLoading, hideLoading } from '@ykz/ykz-util/base';
import databus, { Origins } from '@ykz/ykz-http/core';

/**
 * [ycf-coupon-receive 组件]
 * eg:
 *   <ycf-coupon-receive></ycf-coupon-receive>
 */
export default {
  name: 'coupon_receive',
  data: function data() {
    return {
      modalVisible: false,
      //遮罩层
      visible: false,
      //显示可用现金券列表

      showList: [],
      showType: -1,
      isHasReceived: false,
      showEnvelopeCoupon: false,
      envelopeCouponSlideDown: true // 弹窗是否滑下，默认为true
    };
  },

  components: {
    Slider: Slider
  },
  props: {
    coin: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    couponList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    isShowCoupon: function isShowCoupon() {
      return this.couponList && this.couponList.length > 0;
    }
    // showList: function () {
    //     return this.couponList && this.couponList.length > 0 ? JSON.parse(JSON.stringify(this.couponList)).splice(0, 3) : [];
    // }
  },

  created: function created() {},
  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    console.log('ycf组件初始化：coupon_receive', this.coin, this.couponList);
    window.componentCenter.couponReceive = this;
  },
  watch: {
    visible: function visible(val, oldVal) {
      if (val && !oldVal) {
        // this.modalVisible = true;
        $('.scroll-area').css('overflow-y', 'hidden');
      } else {
        var that = this;
        setTimeout(function () {
          // that.modalVisible = false;
          $('.scroll-area').css('overflow-y', 'auto');
        }, 280);
      }
      this.handleVisible(val);
      this.showType === 1 && this.isHasAssignedCoupon();
    }
  },
  methods: {
    setVisible: function setVisible() {
      this.visible = true;
    },
    //向上滑动显示相关推荐弹框弹框
    slideUpEnvelopeCoupon: function slideUpEnvelopeCoupon(_this) {
      this._this != _this && (this._this = _this || {});
      var that = this;
      that.showEnvelopeCoupon = true;
      setTimeout(function () {
        that.envelopeCouponSlideDown = false;
      }, 30);
    },
    //向下滑动隐藏相关推荐弹框弹框
    slideDownEnvelopeCoupon: function slideDownEnvelopeCoupon() {
      var that = this;
      that.envelopeCouponSlideDown = true;
      setTimeout(function () {
        that.showEnvelopeCoupon = false;
      }, 300);
    },
    generatedList: function generatedList() {
      var list = this.couponList,
        unreceivedList = [],
        receivedList = list.filter(function (item) {
          if (item.hasAssigned === 1) {
            return true;
          } else {
            unreceivedList.push(item);
            return false;
          }
        });
      if (receivedList && receivedList.length > 0) {
        this.showList = receivedList.length > 3 ? receivedList.splice(0, 3) : receivedList;
        this.isHasReceived = true;
      } else {
        this.showList = unreceivedList.length > 3 ? unreceivedList.splice(0, 3) : unreceivedList;
        this.isHasReceived = false;
      }
    },
    // 是否有未领取券
    isHasAssignedCoupon: function isHasAssignedCoupon() {
      if (this.couponList && this.couponList.length > 0) {
        var flag = this.couponList.some(function (item) {
          return item.hasAssigned === 0;
        });
        flag ? this.showType = 1 : this.showType = 2;
      } else {
        this.showType = 3;
      }
    },
    //处理弹窗
    handleVisible: function handleVisible(flag) {
      if (window.location.hash.replace('#', '') != 'couponReceive') {
        if (flag === true) {
          window.location.hash = 'couponReceive';
        }
      } else {
        window.history.go(-1);
      }
    },
    // 领取券
    handleReceive: function handleReceive(index) {
      var item = this.couponList[index],
        that = this;
      if (item.hasAssigned === 1) {
        return;
      } else {
        var that = this;
        databus({
          type: 'POST',
          url: '/api/coupon/assignSingleCoupon',
          data: {
            activityId: item.activityId,
            couponId: item.couponId
          },
          origin: Origins.API_ACT,
          success: function success(res) {
            if (res.code == 1000 && res.bcode == 100) {
              var len = item.onceNum;
              if (item.coupoNum === 1) {
                len--;
                item.hasAssigned = 1;
                item.assignNum = 1;
              }
              for (var i = 0; i < len; i++) {
                var newItem = JSON.parse(JSON.stringify(item));
                newItem.hasAssigned = 1;
                newItem.coupoNum = 0;
                newItem.assignNum = 1;
                that.couponList.splice(index, 0, newItem);
              }
              item.coupoNum--;
              that.generatedList();
              // item.hasAssigned = 1;
            } else {
              toast(res.message);
            }
          },
          error: function error(res) {
            toast(res.message);
          },
          beforeSend: function beforeSend() {
            showLoading();
          },
          complete: function complete() {
            hideLoading();
          }
        });
      }
    }
  },
  filters: {
    //折扣处理
    discountFilter: function discountFilter(value) {
      var str = value.toString().split('.')[1];
      return str[0] + '.' + (str[1] ? str[1] : '0');
    },
    //日期处理
    dateFilter: function dateFilter(value) {
      return value.replace(/-/g, '.');
    },
    //金额处理
    amountFilter: function amountFilter(value) {
      return (parseFloat(value) / 100).toFixed(1);
    },
    textFilter: function textFilter(coupon) {
      if (coupon.amountType === 'fixed') {
        var text1 = (parseFloat(coupon.amountAttr.amount) / 100).toFixed(1);
        return coupon.lowerLimit == 0 ? '立减' + text1 : '满' + (parseFloat(coupon.lowerLimit) / 100).toFixed(1) + '减' + text1;
      } else {
        var str = coupon.amountAttr.discount.toString().split('.')[1],
          text2 = str[0] + '.' + (str[1] ? str[1] : '0') + '折';
        return coupon.lowerLimit == 0 ? '无门槛' + text2 : '满' + (parseFloat(coupon.lowerLimit) / 100).toFixed(1) + '元' + text2;
      }
    }
  },
  inheritAttrs: false
};